import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { OpenFeature } from '@openfeature/web-sdk'
import { StructureElement } from 'types/structureElement.type'

export const UnleashProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const unitSelected = useSelector((state: any) => state.unitSelected.data)

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const allUnits = useSelector((state: any) => state.units.data)
  const currentUnit = allUnits.find(
    (unit: StructureElement) => unit.plt_codigo === unitSelected
  )

  useEffect(() => {
    if (currentUnit?.cli_codigo) {
      OpenFeature.setContext({
        clientId: currentUnit?.cli_codigo,
        unitId: currentUnit?.plt_codigo,
      })
      console.log(
        `Contexto Unleash atualizado: clientId=${currentUnit?.cli_codigo}`
      )
    }
  }, [currentUnit])

  return children
}
